'use client'

import { useSession } from '@/hooks/session'
import { hasRole } from '@/hooks/role'
import { supabase } from '@/supabase'
import { Button, Card, Checkbox, Input, message, Typography } from 'antd'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const { Title } = Typography

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`

const FormContainer = styled(Card)`
  min-width: 400px;
`

const FormContent = styled.div`
  display: grid;
  gap: 10px;
`

export default function Login() {
  const [messageApi, contextHolder] = message.useMessage()
  const { push } = useRouter()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [rememberMe, setRememberMe] = useState(false)
  const session = useSession()
  const canReadCustomer = hasRole('READ_CUSTOMER')
  const canReadUser = hasRole('READ_USER')
  const canEditSystem = hasRole('SYSTEM_EDITOR')

  const getRedirectPath = () => {
    if (canReadCustomer === 'PERMITTED') {
      return '/app/customers'
    }
    if (canReadUser === 'PERMITTED') {
      return '/app/users'
    }

    if (canEditSystem === 'PERMITTED') {
      return '/app/settings'
    }

    return '/app'
  }

  const setup = async () => {
    if (
      session.state.type === 'LOGGED_IN' &&
      canReadCustomer !== 'LOADING' &&
      canReadUser !== 'LOADING'
    ) {
      push(getRedirectPath())
    }
  }
  useEffect(() => {
    setup()
  }, [session, canReadCustomer, canReadUser, canEditSystem])

  useEffect(() => {
    const savedRememberMe = localStorage.getItem('rememberMe')
    if (savedRememberMe === 'true') {
      const savedEmail = localStorage.getItem('savedEmail')
      const savedPassword = localStorage.getItem('savedPassword')
      if (savedEmail && savedPassword) {
        setEmail(savedEmail)
        setPassword(savedPassword)
        setRememberMe(true)
      }
    }
  }, [])

  const onSubmit = async () => {
    try {
      const result = await supabase.auth.signInWithPassword({
        email,
        password,
      })
      if (result.error) {
        console.error('sign in failed', result.error)
        messageApi.error('Sign in failed')
      } else {
        if (rememberMe) {
          localStorage.setItem('rememberMe', 'true')
          localStorage.setItem('savedEmail', email)
          localStorage.setItem('savedPassword', password)
        } else {
          localStorage.removeItem('rememberMe')
          localStorage.removeItem('savedEmail')
          localStorage.removeItem('savedPassword')
        }
        await session.update()
        messageApi.success('Sign in success')
      }
    } catch (error) {
      console.error('login fail', error)
      messageApi.error('Something went wrong try again later')
    }
  }

  return (
    <Container style={{ opacity: session.state.type === 'LOGGED_OUT' ? 1 : 0 }}>
      {contextHolder}
      <FormContainer>
        <FormContent>
          <Title level={2} style={{ margin: 0 }}>
            Login
          </Title>
          <Input
            placeholder='email'
            name='email'
            onChange={e => setEmail(e.target.value)}
            value={email}
          />
          <Input.Password
            placeholder='password'
            name='password'
            onChange={e => setPassword(e.target.value)}
            value={password}
          />
          <Checkbox
            checked={rememberMe}
            onChange={e => setRememberMe(e.target.checked)}
          >
            Remember me
          </Checkbox>
          <Button
            type='primary'
            disabled={email.length === 0 || password.length === 0}
            onClick={onSubmit}
          >
            Submit
          </Button>
        </FormContent>
      </FormContainer>
    </Container>
  )
}
